import { _ } from "../../vendor";
import InboomaBaseModel from "./InboomaBaseModel";

export default InboomaBaseModel.extend({
  urlRoot: "/connects/deleteStripeBankAccount",

  _rbac: {
    admin: {
      read: true,
      write: true,
      edit: true,
      remove: true,
    },
    user: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
  },

  defaults: {
    id: "",
    client_id: "",
    account_holder_name: "",
    bank_code: "",
    account_ibn_number: "",
    created: "",
    modified: "",
    deleted: null,
  },
});
